module.exports = __webpack_public_path__ + "img/micapp.755f32a0.png";